import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10edcf43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"#e70126"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"120px"} }, " 点击【确认购卡】将扣减企业账户余额支付给发卡公司，请仔细核对购卡信息并确保账户余额充足。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "所属企业"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.enterpriseName), 1)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { label: "预付卡名称" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.cardName), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "卡类型" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.cardList[_ctx.detailInfo.cardType]), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "面额" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.nominalAmount) + " 元", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "数量" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.num) + " 张", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "购卡总额" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.totalNominalAmount) + " 元", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "制卡费用" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.cardFee) + " 元", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "服务费用" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.serviceFee) + " 元", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_divider, { dashed: "" }),
      _createVNode(_component_a_form_item, { label: "应付总额" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.detailInfo.totalEnterpriseRealAmount) + " 元", 1)
        ]),
        _: 1
      }),
      _hoisted_2
    ]),
    _: 1
  }, 8, ["label-col", "wrapper-col"]))
}